'use client';

import {useContext, useSyncExternalStore} from 'react';
import {ActiveScreenIdSubscriptionContext} from './ActiveScreenIdProvider';

/**
 * Returns the full selected-screens array. The first element is the primary
 * active id (mirrored to the URL). Causes a re-render whenever the array's
 * identity changes (every selection mutation). Prefer useActiveScreenId or
 * useIsScreenSelected when you only need a slice.
 */
export function useSelectedScreenIds(): string[] {
  const {subscribe, getSnapshot} = useContext(
    ActiveScreenIdSubscriptionContext,
  );

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
